import { GET, POST, PUT, DELETE } from "../../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchOfficeRequest = () =>
  GET("user/ou").pipe(map((response: any) => response));

export const fetchGetOfficesConfiguration = () =>
  GET("external-portal/admin/office").pipe(map((response: any) => response));

export const fetchGetSingleOfficeConfiguration = (officeId: string) =>
  GET(`external-portal/admin/office/${officeId}`).pipe(
    map((response: any) => response)
  );

export const fetchCreateOfficeConfiguration = (body: any) =>
  POST(`external-portal/admin/office`, body).pipe(
    map((response: any) => response)
  );

export const fetchModifyOfficeConfiguration = (payload: any) => {
  const { officeId, body } = payload;
  return PUT(`external-portal/admin/office/${officeId}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchDeleteOfficeConfiguration = (officeId: string) =>
  DELETE(`external-portal/admin/office/${officeId}`).pipe(
    map((response: any) => response)
  );

export const fetchGetCompaniesConfiguration = () =>
  GET("external-portal/admin/company").pipe(map((response: any) => response));

export const fetchGetSingleCompanyConfiguration = (counterId: string) =>
  GET(`external-portal/admin/company/${counterId}`).pipe(
    map((response: any) => response)
  );

export const fetchCreateCompanyConfiguration = (body: any) =>
  POST(`external-portal/admin/company`, body).pipe(
    map((response: any) => response)
  );

export const fetchModifyCompanyConfiguration = (payload: any) => {
  const { companyId, body } = payload;
  return PUT(`external-portal/admin/company/${companyId}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchDeleteCompanyConfiguration = (companyId: string) =>
  DELETE(`external-portal/admin/company/${companyId}`).pipe(
    map((response: any) => response)
  );

export const fetchGetAllFields = () =>
  GET("external-portal/admin/field").pipe(map((response: any) => response));

export const fetchCreateField = (body: any) =>
  POST(`external-portal/admin/field`, body).pipe(
    map((response: any) => response)
  );

export const fetchGetFieldById = (fieldId: string) =>
  GET(`external-portal/admin/field/${fieldId}`).pipe(
    map((response: any) => response)
  );

export const fetchModifyFieldById = (payload: any) => {
  const { fieldId, body } = payload;
  return PUT(`external-portal/admin/field/${fieldId}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchDeleteFieldById = (fieldId: string) =>
  DELETE(`external-portal/admin/field/${fieldId}`).pipe(
    map((response: any) => response)
  );

export const fetchGetCountersConfiguration = () =>
  GET("external-portal/admin/counter").pipe(map((response: any) => response));

export const fetchGetSingleCounterConfiguration = (counterId: string) =>
  GET(`external-portal/admin/counter/${counterId}`).pipe(
    map((response: any) => response)
  );

export const fetchCreateCounterConfiguration = (body: any) =>
  POST(`external-portal/admin/counter`, body).pipe(
    map((response: any) => response)
  );

export const fetchModifyCounterConfiguration = (payload: any) => {
  const { counterId, body } = payload;
  return PUT(`external-portal/admin/counter/${counterId}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchDeleteCounterConfiguration = (counterId: string) =>
  DELETE(`external-portal/admin/counter/${counterId}`).pipe(
    map((response: any) => response)
  );

export const fetchGetButtonsByRole = (role: string) =>
  GET(`external-portal/admin/buttons/${role}`).pipe(
    map((response: any) => response)
  );

export const fetchGetAllComboOptions = () =>
  GET("external-portal/admin/comboOptions").pipe(
    map((response: any) => response)
  );

export const fetchGetComboOptions = (field: string) =>
  GET(`external-portal/admin/comboOptions/${field}`).pipe(
    map((response: any) => response)
  );

export const fetchModifyComboOptions = (body: any) =>
  PUT(`external-portal/admin/comboOptions`, body).pipe(
    map((response: any) => response)
  );

export const fetchCreateComboOptions = (body: any) =>
  POST(`external-portal/admin/comboOptions`, body).pipe(
    map((response: any) => response)
  );

export const fetchDeleteComboOptions = (field: string, name: string) =>
  DELETE(`external-portal/admin/comboOptions/${field}/${name}`).pipe(
    map((response: any) => response)
  );

export const fetchGetAllConfigurations = () =>
  GET("external-portal/admin/configurations/all").pipe(
    map((response: any) => response)
  );

export const fetchModifyConfiguration = (body: any) =>
  PUT(`external-portal/admin/configurations/update`, body).pipe(
    map((response: any) => response)
  );

export const fetchDeleteConfiguration = (code: string) =>
  DELETE(`external-portal/admin/configurations/${code}`).pipe(
    map((response: any) => response)
  );

export const fetchGetFieldVisibilities = () =>
  GET("external-portal/admin/fieldVisibility").pipe(
    map((response: any) => response)
  );

export const fetchCreateFieldVisibility = (body: any) =>
  POST(`external-portal/admin/fieldVisibility`, body).pipe(
    map((response: any) => response)
  );

export const fetchGetFieldVisibilityById = (payload: any) => {
  const { fieldVisibilityId, roleId } = payload;
  return GET(
    `external-portal/admin/fieldVisibility/${fieldVisibilityId}/${roleId}`
  ).pipe(map((response: any) => response));
};

export const fetchModifyFieldVisibilityById = (payload: any) => {
  const { fieldVisibilityId, body } = payload;
  return PUT(
    `external-portal/admin/fieldVisibility/${fieldVisibilityId}`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchModifyFieldVisibility = (body: any) =>
  PUT(`external-portal/admin/fieldVisibility`, body).pipe(
    map((response: any) => response)
  );

export const fetchDeleteFieldVisibilityById = (payload: any) => {
  const { fieldVisibilityId, roleId } = payload;
  return DELETE(
    `external-portal/admin/fieldVisibility/${fieldVisibilityId}/${roleId}`
  ).pipe(map((response: any) => response));
};

export const fetchGetAllOUEnrichments = () =>
  GET("external-portal/admin/OUEnrichment").pipe(
    map((response: any) => response)
  );

export const fetchCreateOUEnrichment = (body: any) =>
  POST(`external-portal/admin/OUEnrichment`, body).pipe(
    map((response: any) => response)
  );

export const fetchGetOUEnrichmentById = (OUEnrichmentId: string) =>
  GET(`external-portal/admin/OUEnrichment/${OUEnrichmentId}`).pipe(
    map((response: any) => response)
  );

export const fetchModifyOUEnrichmentById = (payload: any) => {
  const { OUEnrichmentId, body } = payload;
  return PUT(`external-portal/admin/OUEnrichment/${OUEnrichmentId}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchDeleteOUEnrichmentById = (OUEnrichmentId: string) =>
  DELETE(`external-portal/admin/OUEnrichment/${OUEnrichmentId}`).pipe(
    map((response: any) => response)
  );

export const fetchManagementButtonsForRole = (body: any) =>
  POST(`external-portal/admin/buttons/management`, body).pipe(
    map((response: any) => response)
  );

export const fetchGetAllRoles = () =>
  GET("authentication/admin/view-roles").pipe(map((response: any) => response));
